import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlathubComponent } from './simple-icons-flathub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlathubComponent ],
    exports:      [ SimpleIconsFlathubComponent ],
    bootstrap:    []
})
export class SimpleIconsFlathubModule {}
